/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../node_modules/ngx-tooltip/TooltipContent.ngfactory';
import * as i2 from 'ngx-tooltip/TooltipContent';
import * as i3 from '@angular/common';
import * as i4 from 'ngx-tooltip/Tooltip';
import * as i5 from '@swimlane/ngx-datatable/release/components/columns/column.directive';
import * as i6 from '@swimlane/ngx-datatable/release/components/columns/column-cell.directive';
import * as i7 from '../../../../../node_modules/@swimlane/ngx-datatable/release/components/datatable.component.ngfactory';
import * as i8 from '@swimlane/ngx-datatable/release/components/datatable.component';
import * as i9 from '@swimlane/ngx-datatable/release/services/scrollbar-helper.service';
import * as i10 from '@swimlane/ngx-datatable/release/services/dimensions-helper.service';
import * as i11 from '../../../../../../app/components/Managment/orderManagement/tableView/order-table-view.component';
import * as i12 from '@angular/router';
import * as i13 from '../../../../../../app/services/configService';
import * as i14 from '../../../../../../app/services/userViewService';
const styles_OrderTableViewComponent:any[] = ([] as any[]);
export const RenderType_OrderTableViewComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_OrderTableViewComponent,data:{}});
function View_OrderTableViewComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),2,'tooltip-content',[['class',''],['placement','right']],(null as any),
      (null as any),(null as any),i1.View_TooltipContent_0,i1.RenderType_TooltipContent)),
      i0.ɵdid(4243456,[['myTooltip',4]],0,i2.TooltipContent,[i0.ElementRef,i0.ChangeDetectorRef],
          {placement:[0,'placement'],animation:[1,'animation']},(null as any)),(_l()(),
          i0.ɵted(0,[' ',' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),6,'div',[['class','card-header']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(16777216,(null as any),(null as any),3,'i',[['class',
          'material-icons'],['tooltipPlacement','right']],(null as any),[[(null as any),
          'focusin'],[(null as any),'mouseenter'],[(null as any),'focusout'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('focusin' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,9).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseenter' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,9).show()) !== false);
          ad = (pd_1 && ad);
        }
        if (('focusout' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,9).hide()) !== false);
          ad = (pd_2 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,9).hide()) !== false);
          ad = (pd_3 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i3.NgClass,[i0.IterableDiffers,
          i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
          'ngClass']},(null as any)),i0.ɵdid(16384,(null as any),0,i4.Tooltip,[i0.ViewContainerRef,
          i0.ComponentFactoryResolver],{content:[0,'content'],tooltipPlacement:[1,
          'tooltipPlacement']},(null as any)),(_l()(),i0.ɵted((null as any),[' ',' '])),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'right';
        const currVal_1:any = true;
        _ck(_v,2,0,currVal_0,currVal_1);
        const currVal_3:any = 'material-icons';
        const currVal_4:any = (((_v.context.value == _co.orderStatus.Closed) || (_v.context.value == _co.orderStatus.BorderCrossed))? 'icon-green': 'icon-orange');
        _ck(_v,8,0,currVal_3,currVal_4);
        const currVal_5:any = i0.ɵnov(_v,2);
        const currVal_6:any = 'right';
        _ck(_v,9,0,currVal_5,currVal_6);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_2:any = _co.orderHelper.getTooltipText(_v.context.value);
        _ck(_v,3,0,currVal_2);
        const currVal_7:any = _co.orderHelper.getOrderIcon(_v.context.value);
        _ck(_v,10,0,currVal_7);
      });
}
function View_OrderTableViewComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),[' ',' ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.orderHelper.formatValue((<any>_v.parent).context.$implicit.Property,
        (<any>_v.parent).context.$implicit.Name,_v.context.row,_co.canadianCurrencyCodes);
    _ck(_v,0,0,currVal_0);
  });
}
function View_OrderTableViewComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),10,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          7,'ngx-datatable-column',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(16384,[[1,4]],2,i5.DataTableColumnDirective,
          ([] as any[]),{name:[0,'name'],prop:[1,'prop'],resizeable:[2,'resizeable'],
              sortable:[3,'sortable']},(null as any)),i0.ɵqud(335544320,7,{cellTemplate:0}),
      i0.ɵqud(335544320,8,{headerTemplate:0}),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵand(0,[[7,2]],(null as any),1,(null as any),View_OrderTableViewComponent_4)),
      i0.ɵdid(16384,(null as any),0,i6.DataTableColumnCellDirective,[i0.TemplateRef],
          (null as any),(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _v.context.$implicit.Name;
    const currVal_1:any = _v.context.$implicit.Property;
    const currVal_2:any = false;
    const currVal_3:any = _co.isSortable(_v.context.$implicit.Property);
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_OrderTableViewComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),18,'ngx-datatable',
      [['class','material ngx-datatable']],[[2,'fixed-header',(null as any)],[2,'fixed-row',
          (null as any)],[2,'scroll-vertical',(null as any)],[2,'scroll-horz',(null as any)],
          [2,'selectable',(null as any)],[2,'checkbox-selection',(null as any)],[2,
              'cell-selection',(null as any)],[2,'single-selection',(null as any)],
          [2,'multi-selection',(null as any)],[2,'multi-click-selection',(null as any)]],
      [[(null as any),'scroll'],[(null as any),'activate'],[(null as any),'sort'],
          [(null as any),'reorder'],['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onWindowResize()) !== false);
          ad = (pd_0 && ad);
        }
        if (('scroll' === en)) {
          const pd_1:any = ((<any>_co.onScroll($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('activate' === en)) {
          const pd_2:any = ((<any>_co.onRowClicked($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('sort' === en)) {
          const pd_3:any = ((<any>_co.handleSort($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('reorder' === en)) {
          const pd_4:any = ((<any>_co.handleDragAndDrop($event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },i7.View_DatatableComponent_0,i7.RenderType_DatatableComponent)),i0.ɵdid(5619712,
      (null as any),4,i8.DatatableComponent,[[1,i9.ScrollbarHelper],[1,i10.DimensionsHelper],
          i0.ChangeDetectorRef,i0.ElementRef,i0.KeyValueDiffers],{rows:[0,'rows'],
          scrollbarV:[1,'scrollbarV'],rowHeight:[2,'rowHeight'],columnMode:[3,'columnMode'],
          headerHeight:[4,'headerHeight'],externalSorting:[5,'externalSorting'],reorderable:[6,
              'reorderable'],sortType:[7,'sortType'],sorts:[8,'sorts']},{scroll:'scroll',
          activate:'activate',sort:'sort',reorder:'reorder'}),i0.ɵqud(603979776,1,
      {columnTemplates:1}),i0.ɵqud(335544320,2,{rowDetail:0}),i0.ɵqud(335544320,3,
      {groupHeader:0}),i0.ɵqud(335544320,4,{footer:0}),(_l()(),i0.ɵted((null as any),
      [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'ngx-datatable-column',
      [['name',''],['prop','Status']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i0.ɵdid(16384,[[1,4]],2,i5.DataTableColumnDirective,([] as any[]),
      {name:[0,'name'],prop:[1,'prop']},(null as any)),i0.ɵqud(335544320,5,{cellTemplate:0}),
      i0.ɵqud(335544320,6,{headerTemplate:0}),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵand(0,[[5,2]],(null as any),1,(null as any),View_OrderTableViewComponent_2)),
      i0.ɵdid(16384,(null as any),0,i6.DataTableColumnCellDirective,[i0.TemplateRef],
          (null as any),(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_OrderTableViewComponent_3)),i0.ɵdid(802816,(null as any),
          0,i3.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_10:any = _co.orders;
    const currVal_11:any = true;
    const currVal_12:any = _co.rowHeight;
    const currVal_13:any = 'force';
    const currVal_14:any = _co.headerHeight;
    const currVal_15:any = true;
    const currVal_16:any = false;
    const currVal_17:any = 'single';
    const currVal_18:any = _co.getSortedColumn;
    _ck(_v,1,0,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18);
    const currVal_19:any = '';
    const currVal_20:any = 'Status';
    _ck(_v,8,0,currVal_19,currVal_20);
    const currVal_21:any = _co.tableColumns;
    _ck(_v,17,0,currVal_21);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).isFixedHeader;
    const currVal_1:any = i0.ɵnov(_v,1).isFixedRow;
    const currVal_2:any = i0.ɵnov(_v,1).isVertScroll;
    const currVal_3:any = i0.ɵnov(_v,1).isHorScroll;
    const currVal_4:any = i0.ɵnov(_v,1).isSelectable;
    const currVal_5:any = i0.ɵnov(_v,1).isCheckboxSelection;
    const currVal_6:any = i0.ɵnov(_v,1).isCellSelection;
    const currVal_7:any = i0.ɵnov(_v,1).isSingleSelection;
    const currVal_8:any = i0.ɵnov(_v,1).isMultiSelection;
    const currVal_9:any = i0.ɵnov(_v,1).isMultiClickSelection;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9);
  });
}
export function View_OrderTableViewComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_OrderTableViewComponent_1)),i0.ɵdid(16384,(null as any),0,i3.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
      [' ']))],(_ck,_v) => {
    var _co:i11.OrderTableViewComponent = _v.component;
    const currVal_0:any = (_co.orders && (_co.orders.length > 0));
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_OrderTableViewComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'order-table-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_OrderTableViewComponent_0,
      RenderType_OrderTableViewComponent)),i0.ɵdid(49152,(null as any),0,i11.OrderTableViewComponent,
      [i12.ActivatedRoute,i13.ConfigService,i0.ElementRef,i12.Router,i14.UserViewService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const OrderTableViewComponentNgFactory:i0.ComponentFactory<i11.OrderTableViewComponent> = i0.ɵccf('order-table-view',
    i11.OrderTableViewComponent,View_OrderTableViewComponent_Host_0,{config:'config',
        paramsInUrl:'paramsInUrl',orders:'orders',isLoading:'isLoading',tableColumns:'tableColumns'},
    {searchEvent:'searchEvent'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/Managment/orderManagement/tableView/order-table-view.component.ngfactory.ts